import { type CSSProperties } from "react";
import { type Quote } from "../types/quote";
import { QuoteSource } from "./QuoteSource";

interface QuoteCardViewProps {
  quotes: Quote[];
}

export function QuoteCardView({ quotes }: QuoteCardViewProps) {
  return (
    <section style={styles.grid}>
      {quotes.map((quote) => (
        <article key={quote.id} style={styles.card}>
          <p style={styles.content}>&ldquo;{quote.content}&rdquo;</p>

          <footer style={styles.meta}>
            {quote.author ? <span style={styles.author}>{quote.author}</span> : null}
            <QuoteSource
              source={quote.source}
              style={styles.source}
              linkStyle={styles.sourceLink}
            />
          </footer>
        </article>
      ))}
    </section>
  );
}

const styles = {
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
    gap: "16px",
  },
  card: {
    display: "flex",
    minHeight: "180px",
    flexDirection: "column",
    justifyContent: "space-between",
    gap: "24px",
    padding: "22px",
    border: "1px solid var(--border)",
    borderRadius: "8px",
    background: "rgba(255, 255, 255, 0.04)",
    boxShadow: "var(--shadow)",
  },
  content: {
    color: "var(--text-h)",
    fontSize: "20px",
    lineHeight: 1.45,
  },
  meta: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    paddingTop: "14px",
    borderTop: "1px solid var(--border)",
  },
  author: {
    color: "var(--text-h)",
    fontSize: "15px",
    fontWeight: 700,
  },
  source: {
    color: "var(--text)",
    fontSize: "14px",
  },
  sourceLink: {
    color: "var(--accent)",
    fontSize: "14px",
    overflowWrap: "anywhere",
  },
} satisfies Record<string, CSSProperties>;
